module.exports = __webpack_public_path__ + "static/media/lvjian-zjg.e1a4f063.jpg";